
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Yleiset',
	'widgetId': 'Pienoisohjelman tunnus',
	'widgetType': 'Pienoisohjelman tyyppi',
	'serviceability': 'Huollettavuus',
	'copyButton': 'Kopioi',
	'closeButton': 'Sulje',
	'specification': 'Määritys',
	'viewSpecification': 'Näytä määritys'
});
